import { AppIcons } from "../constants/app-icons";
import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
export default class UserService extends ApiService {
  template = "defaultTemplate";
  namespace = "user";
  DOMAIN = DOMAIN.USERS;
  Width = 1100;
  icon = "User";
  STATUSES = [
    { name: "Active", key: 1 },
    { name: "In-active", key: 0 },
  ];
  singular = this.terminology.user.singular;
  plural = this.terminology.user.plural;
  vowel = this.terminology.user.vowel;
  action = "action";
  favicon = "Property";
  gemItems = [
    {
      key: "create",
      label: this.t("addAnEntity", { entity: "User" }),
      icon: AppIcons.PLUS,
    },
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "listing",
      label: this.t("addAEntity", { entity: "User" }),
      icon: AppIcons.MAIL,
    },
    {
      key: "listing",
      label: this.t("all") + this.t("userGroup", 1),
      icon: AppIcons.MAIL,
    },
    {
      key: "listing",
      label: this.t("generateReport"),
      icon: AppIcons.DOCUMENT,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.USER_SILHOUETTE,
      field: "display_name",
    },

    {
      header: this.t("email"),
      icon: AppIcons.MAIL,
      field: "email",
    },
    {
      header: this.t("status"),
      icon: AppIcons.LIGHTNING,
      field: "status",
      template: (data) => {
        return this.parseStatus(data["status"]);
      },
    },
    {
      header: this.t("created"),
      icon: AppIcons.CALENDAR,
      field: "created_at",
      template: (data) => {
        return new Date(data.created_at * 1000).toLocaleDateString("en-US");
      },
    },
  ];
  navItems = [
    {
      key: "listing",
      label: this.t("allEntity", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: DOMAIN.VENDOR,
      icon: AppIcons.DISABLE,
    },
  ];
  listMenuItems = [
    {
      key: "edit",
      label: "Open this " + this.singular,
      icon: AppIcons.EDIT,
    },
    {
      key: "announce",
      label: "announceThisEntity",
      services: DOMAIN.MESSAGES,
      icon: AppIcons.BULLETS,
    },
    {
      key: "email",
      label: "emailThisEntity",
      icon: AppIcons.MAIL,
    },
    {
      key: "bookmark",
      label: "bookmarkThisEntity",
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: "inactiveThisEntity",
      icon: AppIcons.LOCK2,
    },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Good",
      icon: AppIcons.LIST,
    },
  ];

  filterItems = [
    { name: "Folders", value: "folders" },
    { name: "Type", value: "type" },
    { name: "Categoris", value: "categoris" },
  ];

  constructor() {
    super("users");
  }
}
